import { z } from "zod";

const parentSchema = z.object({
  id: z.string().uuid({ message: "Id is required." }),
});

const modelSchema = z.object({
  id: z.string().uuid({ message: "Id is required." }),
});

const labelSchema = z.object({
  id: z.string().uuid({ message: "Label is required." }),
});

// The combobox is bound to label.id, so leaving a label unset gives { id: null } rather than no
// object at all. Read that as no label, or an empty selection fails as a malformed one.
const optionalLabelSchema = z.preprocess(
  (value) => (value && typeof value === "object" && value.id ? value : null),
  labelSchema.nullable()
);

const CreateItemSchema = z
  .object({
    name: z
      .string()
      .min(1, { message: "Name is required." })
      .max(400, { message: "Name must not be longer than 400 characters." }),
    shortCode: z.string().optional().nullable(),
    description: z.string().optional().nullable(),
    model: modelSchema.required(),
    parent: parentSchema.optional().nullable(),
    label: optionalLabelSchema,
    isLeaf: z.boolean().optional().default(false),
    customFields: z.record(z.string(), z.any()).optional().nullable(),
  })
  .strict();

export default CreateItemSchema;
